import Preloader from "../../../components/blocks/Preloader";

const BOOK_A_CALL_URL =
  "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ1UiDnxpXuDVjFE6MHYbt4nDg7tB8-2f4wJ98R2IU2zajqPOm9CUJo57fdGSKZqPxmWbNk-wHBR";

const CoursePaymentSection = ({
  courses,
  loading,
  selectedCourseData,
  selectedLocation,
}) => {
  const course = courses?.find((a) => a?.title === selectedCourseData?.title);
  const isAfrica = selectedLocation?.name === "Africa" || !selectedLocation;
  const currency = isAfrica ? "$" : "$";
  const payment = isAfrica ? course?.paymentInEuro : course?.paymentInEuro;

  const hasFull = Boolean(payment?.outRightPaymentAmount);
  const hasPart = Boolean(payment?.partPaymentAmount);
  const enrolLink = course?.enrolLink || "/";

  return (
    <section id="pricing" className="bg-white">
      <div className="max-w-[1260px] mx-auto px-4">
        <div className="border border-[#DFE6F7] rounded-[26px] bg-white shadow-course-card mb-8 p-6 md:p-12">
          <div className="text-center max-w-xl mx-auto mb-10">
            <p className="text-primary tracking-[0.19em] uppercase text-[14px] font-extrabold flex items-center justify-center gap-2 mb-4">
              <span className="inline-block w-6 h-[3px] bg-secondary rounded-full" />
              Tuition
            </p>
            <h2 className="text-primary font-bold text-3xl md:text-5xl tracking-tight mb-3">
              Simple, flexible pricing
            </h2>
            <p className="text-[#565656] text-sm md:text-base m-0">
              Pay once or spread it across two instalments — same program, same
              support.
            </p>
          </div>

          {loading ? (
            <Preloader />
          ) : hasFull || hasPart ? (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
              {hasPart && (
                <div className="border border-[#DFE6F7] rounded-[22px] p-7 md:p-9 flex flex-col">
                  <h3 className="text-lg font-semibold text-[#1E2027] mb-5">
                    Part Payment
                  </h3>
                  <strong className="text-primary text-4xl md:text-5xl tracking-tight block mb-2">
                    {currency}
                    {payment.partPaymentAmount}
                  </strong>
                  <p className="text-[#565656] text-xs">
                    Pay {payment.partPaymentPercentageUpfront || "a portion"}{" "}
                    upfront, balance before graduation.
                  </p>

                  <ul className="grid gap-3 my-7">
                    {[
                      `Full ${selectedCourseData?.duration || ""} program`,
                      "All live classes and recordings",
                      "Portfolio project and feedback",
                      "Accredited certificate",
                    ].map((item) => (
                      <li
                        key={item}
                        className="text-sm text-[#1E2027] flex gap-2"
                      >
                        <span className="text-primary font-extrabold">✓</span>
                        {item}
                      </li>
                    ))}
                  </ul>

                  <a
                    href={payment.partPaymentLink || enrolLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-auto text-center border border-primary text-primary font-bold text-sm rounded-xl py-4 focus:outline-none"
                  >
                    Choose part payment
                  </a>
                </div>
              )}

              {hasFull && (
                <div className="relative bg-primary text-white rounded-[22px] p-7 md:p-9 flex flex-col shadow-course-feature-lg">
                  {hasPart && (
                    <span className="absolute -top-3.5 right-7 bg-secondary text-primary rounded-full px-3.5 py-1.5 text-[10px] font-extrabold">
                      BEST VALUE
                    </span>
                  )}
                  <h3 className="text-lg font-semibold mb-5">Pay in Full</h3>
                  <strong className="text-secondary text-4xl md:text-5xl tracking-tight block mb-2">
                    {currency}
                    {payment.outRightPaymentAmount}
                  </strong>
                  <p className="text-[#F0F5FF] text-xs">
                    One-time payment, everything included.
                  </p>

                  <ul className="grid gap-3 my-7">
                    {[
                      "Everything in part payment",
                      "Priority project reviews",
                      "Career and portfolio support",
                      "Full community access",
                    ].map((item) => (
                      <li key={item} className="text-sm flex gap-2">
                        <span className="text-secondary font-extrabold">✓</span>
                        {item}
                      </li>
                    ))}
                  </ul>

                  <a
                    href={payment.outRightPaymentLink || enrolLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-auto text-center bg-secondary text-primary font-bold text-sm rounded-xl py-4 focus:outline-none"
                  >
                    Enrol &amp; save
                  </a>
                </div>
              )}
            </div>
          ) : (
            <div className="text-center max-w-sm mx-auto">
              <p className="text-[#565656] text-sm mb-6">
                Pricing will be confirmed on enrolment for your location.
              </p>
              <a
                href={enrolLink}
                target="_blank"
                rel="noopener noreferrer"
                className="custom-btn custom-btn-with-shadow inline-flex items-center gap-3 bg-secondary text-white font-bold text-sm rounded-xl px-8 py-4 focus:outline-none"
              >
                Enrol Now
              </a>
            </div>
          )}

          <p className="text-center text-[#565656] text-xs mt-8">
            Need help choosing?{" "}
            <a
              href={BOOK_A_CALL_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary font-bold underline underline-offset-4"
            >
              Book a call with an advisor
            </a>
            .
          </p>
        </div>
      </div>
    </section>
  );
};

export default CoursePaymentSection;
